export default __webpack_public_path__ + "91496781f9f5d15c0a076356e95f8f10.svg";